<div class="panel panel-flat">
  <div class="content-group">


    <div class="tabbable">
      <ul class="nav nav-tabs nav-tabs-highlight">
        <li class="active"><a href="#notifications-tab" data-toggle="tab"> <i
              class="icon-bell3 position-left"></i>Notifications</a></li>
        <li><a href="#announcements-tab" data-toggle="tab"> <i
              class="icon-volume-high position-left"></i>Announcements</a></li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane has-padding active" id="notifications-tab">

          <div class="row">

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Date</span>
              <input type="date" name="notificationDate" class="form-control" />
            </div>

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Status</span>
              <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getNotificationsFilter()"
                class="form-control">
                <option value="">All</option>
                <option value="&status=read">Read</option>
                <option value="&status=unread">Unread</option>
                <option value="&status=pending">Pending</option>
              </select>
            </div>

            <div class="col-md-8 form-group required">
              <span class="control-label">&nbsp; </span>
              <div class="btn-group pull-right">
                <a data-toggle="modal" data-target="#notificationModal" type="button"
                  class="btn btn-icon btn-sm bg-brown btn-rounded" id="openNotificationModal">
                  <i class="icon-add position-left"></i> Add Notification</a>
                <a type="button" class="btn btn-icon btn-sm bg-brown btn-rounded">
                  <i class="icon-printer position-left"></i>Print</a>
              </div>
            </div>

          </div>

          <div class="panel-body">

            <div class="row">
              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Title</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let notification of notifications | paginate: { id: 'notifications',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>{{notification?.user?.data?.username}}</td>
                    <td>{{notification.title}}</td>
                    <td>{{notification.content}}</td>
                    <td>{{notification.created_at | date: 'MMM d, y, h:mm:ss a'}}</td>
                    <td>
                      <span class="label label-block label-primary"
                        *ngIf="notification.type === 'Info' || notification.type === 'info'">{{notification.type}}</span>
                      <span class="label label-block label-warning"
                        *ngIf="notification.type === 'Warning' || notification.type === 'warning'">{{notification.type}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="notification.type === 'Danger' || notification.type === 'danger'">{{notification.type}}</span>
                    </td>
                    <td>
                      <span class="label label-block label-default"
                        *ngIf="notification.status === 'Read' || notification.status === 'read'">{{notification.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="notification.status === 'Unread' || notification.status === 'unread'">{{notification.status}}</span>
                      <span class="label label-block bg-brown"
                        *ngIf="notification.status === 'Pending' || notification.status === 'pending'">{{notification.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>

                          <ul class="dropdown-menu dropdown-menu-right">
                            <li>
                              <a (click)="setNotification(notification)">
                                <i class="icon-file-pdf"></i>Update</a>
                            </li>
                            <li>
                              <a href="">
                                <i class="icon-file-excel"></i>Delete</a>
                            </li>
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="javascript:void(0);">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a (click)="changeStatus(notification.id,'read')">
                                    <i class="icon-shuffle"></i> Read</a>
                                </li>
                                <li>
                                  <a (click)="changeStatus(notification.id,'unread')">
                                    <i class="icon-shuffle"></i> Unread</a>
                                </li>
                                <li>
                                  <a (click)="changeStatus(notification.id,'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="notifications.length <= 0">
                    <td colspan="7" class="text-center"><i class="icon-info22">&nbsp;</i> No Notifications Found</td>
                  </tr>
                </tbody>
              </table>
            </div>


            <div class="row" *ngIf="notifications.length > 0">
              <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
              <div class="text-center">

                <pagination-controls id="notifications" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>


          </div>


        </div>

        <div class="tab-pane has-padding" id="announcements-tab">



          <div class="row">

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Date</span>
              <input type="date" name="notificationDate" class="form-control" />
            </div>

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Status</span>
              <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getNotificationsFilter()"
                class="form-control">
                <option value="&status=">All</option>
                <option value="&status=read">Active</option>
                <option value="&status=unread">Inactive</option>
              </select>
            </div>

            <div class="col-md-8 form-group required">
              <span class="control-label">&nbsp; </span>
              <div class="btn-group pull-right">
                <a data-toggle="modal" data-target="#announcementModal" type="button"
                  class="btn btn-icon btn-sm bg-brown btn-rounded" id="openAnnouncementModal">
                  <i class="icon-add position-left"></i> Add Announcement</a>
                <a type="button" class="btn btn-icon btn-sm bg-brown btn-rounded">
                  <i class="icon-printer position-left"></i>Print</a>
              </div>
            </div>

          </div>

          <div class="panel-body">
            <div class="row">
            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th class="text-center">Actions</th>
                </tr>

              </thead>
              <tbody>
                <tr
                  *ngFor="let announcement of announcements | paginate: { id: 'announcements',itemsPerPage: announcementsPerPage,currentPage: announcementsCurrentPage,totalItems: totalItems }">
                  <td>{{announcement.title}}</td>
                  <td>{{announcement.message}}</td>
                  <td>{{announcement.created_at | date: 'MMM d, y, h:mm:ss a'}}</td>
                  <td>
                    <span class="label label-block label-primary"
                      *ngIf="announcement.status === 'Active' || announcement.status === 'active'">{{announcement.status}}</span>
                    <span class="label label-block label-default"
                      *ngIf="announcement.status === 'Inactive' || announcement.status === 'inactive'">{{announcement.status}}</span>
                  </td>
                  <td class="text-center">
                    <ul class="icons-list">
                      <li class="dropdown">
                        <a href="" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="icon-menu9"></i>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-right">
                          <li>
                            <a (click)="setAnnouncement(announcement)">
                              <i class="icon-file-pdf"></i>Update</a>
                          </li>
                          <li>
                            <a href="">
                              <i class="icon-file-excel"></i>Delete</a>
                          </li>
                          <li class="dropdown-submenu dropdown-submenu-left">
                            <a href="#">Change Status</a>
                            <ul class="dropdown-menu">
                              <li>
                                <a (click)="changeAnnouncementStatus(announcement.id,'active')">
                                  <i class="icon-shuffle"></i> Active</a>
                              </li>
                              <li>
                                <a (click)="changeAnnouncementStatus(announcement.id,'inactive')">
                                  <i class="icon-shuffle"></i> Inactive</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr *ngIf="announcements.length <= 0">
                  <td colspan="7" class="text-center"><i class="icon-info22">&nbsp;</i> No Announcements Found</td>
                </tr>
              </tbody>
            </table>
            </div>


            <div *ngIf="announcements.length > 0" class="row">
              <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
              <div class="text-center">

                <pagination-controls id="announcements" (pageChange)="announcementPageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>


          </div>


        </div>

      </div>
    </div>

  </div>
</div>




<!-- Notification modal -->
<div id="notificationModal" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title"><span *ngIf="notification?.id">Update</span><span *ngIf="!notification?.id">Add</span> Notification</h5>
      </div>
      <hr>
      <form name="notificationForm" [formGroup]="notificationForm" novalidate>
        <div class="modal-body">

          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                <label>Title</label>
                <input type="text" placeholder="Notification title" class="form-control" formControlName="title">
              </div>
              <div class="col-sm-12">
                <label>&nbsp;</label><br>
                <label>Message:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="content"
                  placeholder="Notification content. . ."></textarea>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-sm-6 required">
                <span class="control-label">Type: </span>
                <select name="type" required formControlName="type" class="form-control"
                  data-placeholder="Select notification type">
                  <option value="info">Info</option>
                  <option value="warning">Warning</option>
                  <option value="danger">Danger</option>
                </select>
                <div class="help-block" *ngIf="type.invalid && (type.dirty || type.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Notification Type is required.
                  </p>
                </div>
              </div>
              <div class="col-sm-6 required">
                <span class="control-label">Status: </span>
                <select name="status" required formControlName="status" class="form-control"
                  data-placeholder="Select ekub status">
                  <option value="read">Read</option>
                  <option value="unread">Unread</option>
                </select>
                <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Ekub status is required.
                  </p>
                </div>
              </div>

            </div>
          </div>

          <div class="form-group">
            <div class="row">

              <div class="col-sm-6">
                <label>Ekub</label>
                <ng-select [items]="ekubs" placeholder="select ekub" [(ngModel)]="ekub" (change)="getEkubMembers(ekub)"
                  [ngModelOptions]="{standalone: true}" bindValue="id" bindLabel="text" required>
                </ng-select>
              </div>

              <div class="col-sm-6">
                <label>User</label>
                <!--  <ng-select [items]="ekubMembers" [readonly]="isOperationAdd()" placeholder="" formControlName="winner" -->
                <ng-select [items]="ekubMembers" placeholder="" formControlName="user" bindValue="id"
                  bindLabel="username">
                </ng-select>
                <!-- <input type="text" placeholder="User" class="form-control" [(ngModel)]="selectedUser.username"
                  formControlName="user"> -->
              </div>

            </div>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
          <button (click)="addNotification(notification.id)" data-dismiss="modal" class="btn btn-rounded bg-brown"><i
              class="icon-bell3 position-left"></i><span *ngIf="notification?.id">Update</span><span *ngIf="!notification?.id">Add</span> Notification</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /Notification modal -->






<!-- Announcement modal -->
<div id="announcementModal" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title"><span *ngIf="announcement?.id">Update</span><span *ngIf="!announcement?.id">Add</span> Announcement</h5>
      </div>
      <hr>
      <form name="announcementForm" [formGroup]="announcementForm" novalidate>
        <div class="modal-body">
          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                <label>Title</label>
                <input type="text" placeholder="Annoucement title" class="form-control" formControlName="title">
              </div>
              <div class="col-sm-12">
                <label>&nbsp;</label><br>
                <label>Message:</label>
                <textarea rows="5" cols="5" class="form-control" name="message" formControlName="message"
                  placeholder="Annoucement content. . ."></textarea>
              </div>
            </div>
          </div>


          <div class="form-group">
            <div class="row">
              <div class="col-sm-6 required">
                <span class="control-label">Status: </span>
                <select name="status" required formControlName="status" class="form-control"
                  data-placeholder="Select ekub status">
                  <option selected disabled>Status:</option>
                  <option value="pending">Pending</option>
                  <option value="active">Active</option>
                  <option value="completed">Completed</option>
                </select>
                <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Ekub status is required.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
          <button (click)="addAnnouncement(announcement.id)" data-dismiss="modal" class="btn btn-rounded bg-brown">
            <i class="icon-volume-high position-left"></i><span *ngIf="announcement?.id">Update</span><span *ngIf="!announcement?.id">Add</span> Announcement</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /Announcement modal -->